let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aZ2ln")).then(() => parcelRequire('ibkv3'));